import Api from "./api";

// Bound how long we wait on the wellness-configuration call before giving up
// and falling back to the legacy chat widget, so a stalled/non-responding
// backend can never leave the /chatbot page stuck on its loading spinner.
export const CHATBOT_CONFIG_TIMEOUT_MS = 5000;

export const fetchChatbotConfiguration = async (pmEntityID, shortToken) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(
    () => controller.abort(),
    CHATBOT_CONFIG_TIMEOUT_MS
  );

  try {
    if (!pmEntityID || !shortToken) {
      return { shouldEnableChatbot: false };
    }

    const headers = {
      "Content-Type": "application/json",
      "accesstoken": shortToken,
    };

    const payload = {
      pMEntityID: pmEntityID,
    };

    const response = await Api.getWellnessConfiguration(payload, headers, {
      timeout: CHATBOT_CONFIG_TIMEOUT_MS,
      signal: controller.signal,
    });

    return {
      shouldEnableChatbot: response?.entityConfig?.llmCustomerChatbotEnabled !== false,
      data: response,
    };
  } catch (error) {
    // Covers both axios' own `timeout` rejection and the AbortController
    // firing, as well as any other network/server error.
    console.error("Error fetching chatbot configuration:", error);
    return { shouldEnableChatbot: false };
  } finally {
    clearTimeout(timeoutId);
  }
};
